export default __webpack_public_path__ + "static/media/weddingWhite.8f31f52b.svg";